import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const prioritySchema = z.enum(["P1", "P2", "P3"]);

const bugReportRequestSchema = z.object({
  title: z.string(),
  summary: z.string(),
  priority: prioritySchema,
  effective_priority: prioritySchema,
  priority_reason: z.string(),
  account_at_risk: z.boolean(),
  problem: z.string(),
  context: z.string(),
  current_url: z.string(),
  research_done: z.string(),
  troubleshooting: z.object({
    replicated: z.boolean(),
    replicate_result: z.string(),
    checked_config: z.boolean(),
    confirmed_data_discrepancy: z.boolean(),
  }),
  hypothesis: z.string(),
  meta: z
    .object({
      user_id: z.string(),
      email: z.string().nullable(),
      user_full_name: z.string(),
      organization_id: z.string(),
      organization_name: z.string(),
      organization_type: z.string().nullable(),
      customer_type: z.string().nullable(),
      profile: z.string(),
      marketplace: z.string(),
      channel: z.string(),
      time: z.string(),
      timezone: z.string(),
      browser_info: z.object({
        language: z.string(),
        platform: z.string(),
        userAgent: z.string(),
        vendor: z.string(),
      }),
    })
    .passthrough(),
});

export type BugReportRequest = z.infer<typeof bugReportRequestSchema>;

export const bugReportApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "submitBugReport",
    method: "post",
    path: "/bug_report/",
    parameters: [{ name: "body", type: "Body", schema: bugReportRequestSchema }],
    status: 201,
    response: z.object({ ok: z.literal(true) }),
  }).build(),
);
